var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4366 13.2731C12.5072 13.2731 14.1858 11.7201 14.1858 9.80452C14.1858 7.88888 12.5072 6.33594 10.4366 6.33594C8.36604 6.33594 6.6875 7.88888 6.6875 9.80452C6.6875 11.7201 8.36604 13.2731 10.4366 13.2731Z",
    stroke: "#484848",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.2729V6.33573C2 3.94118 4.09818 2 6.68641 2H14.1847C16.7729 2 18.8711 3.94118 18.8711 6.33573V13.2729C18.8711 15.6674 16.7729 17.6086 14.1847 17.6086H6.68641C4.09818 17.6086 2 15.6674 2 13.2729Z",
    stroke: "#484848",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5918 5.04521L15.6024 5.03418",
    stroke: "#484848",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon _instagram_.b84e0626605e33319b14623271e64dfa.svg";
export { ForwardRef as ReactComponent };